'use strict';
 /**
 * @author Maxim Seredkin
 */
import angular from "angular";
import ProjectMaintenanceKindTableDirective from "./directive/projectMaintenanceKindTable";

export default angular.module('investmentProject.project.maintenanceKind', [])
    .directive('projectMaintenanceKindTable', ProjectMaintenanceKindTableDirective)
    .name;